import styled from 'styled-components';
import ds from '../../utils/designSystem';

export const DefaultButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ flex }) => flex && `flex: ${flex}`}
  width: ${props => props.width || '100%'};
  height: ${({ height }) => height};
  background-color: ${ds.colors.blueDark};
  ${({ background }) => background && `background: ${background}`};
  color: ${({ color }) => color || ds.colors.white};
  font-size: ${ds.fontSizes.regular};
  font-weight: 500;
  border: ${props => props.border};
  border-radius: 6px;
  font-family: 'Lexend Deca', sans-serif;
  cursor: pointer;
  position: relative;
  text-transform: ${props => (props.noupper ? '' : 'uppercase')};
  &:focus {
    outline: none;
  }
  transition: opacity 0.3s;
  &:active {
    opacity: 0.6;
    transform: translateY(3px);
  }
  &:disabled {
    opacity: 0.5;
  }

`;

DefaultButton.defaultProps = {
  height: '60px',
  backgroundColor: null,
  type: 'button',
  textDecoration: 'none',
  border: `2px solid ${ds.colors.blueDark}`
};

export const Add = styled.button`
  font-family: ${ds.fontFamily.main};
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  background: ${props => (props.add ? '#0083ff' : '#FF8800')};
  color: white;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  height: 36px;
  width: 100px;
  margin: 10px 0;
  margin-top: 24px;
  margin-left: 7px;
  line-height: 30px;
  text-align: center;
  transition: opacity 0.3s;
  &:active {
    opacity: 0.6;
    transform: translateY(3px);
  }
`;

Add.defaultProps = {
  add: false
};

export const Filter = styled.button`
  font-family: ${ds.fontFamily.main};
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  background: ${props => (props.submit ? '#0083ff' : '#FF8800')};
  color: white;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  border: none;
  height: 36px;
  padding: 0 20px;
  transition: opacity 0.3s;
  &:active {
    opacity: 0.6;
    transform: translateY(3px);
  }
`;

Filter.defaultProps = {
  submit: false
};
